module.exports = __webpack_public_path__ + "static/media/Ultra_Short.c2a7a2b5.svg";